// import { Component, OnInit } from '@angular/core';
import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import { FormGroup, FormControl, FormArray } from "@angular/forms";

import { counterRangeValidator } from "../../components/counter-input/counter-input.component";
import { ModalController, NavController } from "@ionic/angular";
import { AuthService } from "../../../app/services/auth.service";
import { FirebaseService } from "../../../app/firebase/firebase-integration.service";
import { NavigationExtras } from "@angular/router";
import * as firebase from "firebase";

@Component({
  selector: "app-form",
  templateUrl: "./form.page.html",
  styleUrls: ["./form.page.scss"]
})
export class FormPage implements OnInit {
  select_all: boolean;
  rangeForm: any;
  FilterForm: FormGroup;
  radioForm: FormGroup;
  checkboxTagsForm: FormGroup;
  radioTagsForm: FormGroup;
  switchersForm: FormGroup;
  counterForm: any;
  ratingForm: FormGroup;
  radioColorForm: FormGroup;
  inputForm: FormGroup;

  cate_1 = {
    name: { 0: "STEM", 1: "學術", 2: "運動", 3: "舞蹈" },
    list: [
      "Lego Education",
      "Micro：bit",
      "mBot",
      "Scratch",
      "Arduino",
      "3D print",
      "Dash and Dot",
      "VR",
      "種植項目"
    ],
    list2: [
      "中文",
      "英文",
      "數學",
      "phonics",
      "劍橋英語",
      "奧數",
      "珠心算",
      "普通話",
      "朗誦",
      "辯論",
      "書法",
      "新來港學童廣東話班",
      "日語",
      "韓語",
      "西班牙語",
      "法語"
    ],
    list3: [
      "手球隊",
      "足球隊",
      "籃球隊",
      "排球隊",
      "乒乓球",
      "羽毛球",
      "田徑隊",
      "跆拳道",
      "空手道",
      "柔道",
      "足毽",
      "游泳",
      "水上活動",
      "壁球",
      "欖球",
      "射箭",
      "武術",
      "閃避球",
      "跳繩",
      "武術",
      "網球",
      "體適能",
      "其他"
    ],
    list4: [
      "芭蕾舞",
      "社交舞",
      "街舞",
      "K-Pop舞",
      "現代舞",
      "中國舞",
      "爵士舞",
      "Hip-Hop舞"
    ]
  };
  CollapseForm: boolean;
  signin: string;
  displayName: string;
  uid: string;
  photoURL: string;
  showMessageTeachingMaterial: boolean;
  SELECT_ALL: number;

  constructor(
    private navCtrl: NavController,
    private firebaseService: FirebaseService,
    private authService: AuthService,
    private modalCtrl: ModalController
  ) {
    this.checkUserStatus();
    this.inputForm = new FormGroup({
      keyword: new FormControl("")
    });

    this.FilterForm = new FormGroup({
      // cate: new FormControl(""),
      subcate: new FormControl(""),
      class_size: new FormControl({ lower: 1, upper: 42 }),
      target_user_age: new FormControl({ lower: 1, upper: 16 }),
      class_length: new FormControl({ lower: 1, upper: 42 }),
      teaching_materials: new FormControl(""),
      message_teaching_materials: new FormControl(""),
      sq_timelimit: new FormControl(7),
      message: new FormControl("")
    });
    // this.rangeForm = new FormGroup({
    //   single: new FormControl(25),
    //   dual: new FormControl({ lower: 12, upper: 23 })
    // });

    // this.radioTagsForm = new FormGroup({
    //   selected_option: new FormControl("any")
    // });

    // this.switchersForm = new FormGroup({
    //   notifications: new FormControl(true),
    //   email_notifications: new FormControl(false)
    // });

    // this.counterForm = new FormGroup({
    //   counter: new FormControl(5, counterRangeValidator(1, 7)),
    //   counter2: new FormControl(2, counterRangeValidator(1, 5))
    // });

    // this.ratingForm = new FormGroup({
    //   rate: new FormControl(2.5),
    //   rate2: new FormControl(1.5)
    // });

    // this.radioColorForm = new FormGroup({
    //   selected_color: new FormControl("#fc9961")
    // });
  }

  ionViewWillEnter() {
    const userDetail = this.authService.userDetails();
    console.log(userDetail);
    // this.firebaseService.searchUsers().subscribe(data => {
    //   console.log(data);
    // });
  }

  rangeChange(range: Range) {
    console.log("range change", range);
  }

  rangeChangeSecond(range: Range) {}

  changeTargetValue(value): string {
    switch (true) {
      case value === 1:
        return "K1";
      case value === 2:
        return "K2";
      case value === 3:
        return "K3";
      case value === 4:
        return "P1";
      case value === 5:
        return "P2";
      case value === 6:
        return "P3";
      case value === 7:
        return "P4";
      case value === 8:
        return "P5";
      case value === 9:
        return "P6";
      case value === 10:
        return "S1";
      case value === 11:
        return "S2";
      case value === 12:
        return "S3";
      case value === 13:
        return "S4";
      case value === 14:
        return "S5";
      case value === 15:
        return "S6";
      case value >= 16:
        return "大專";
      // case value <= 3:
      //   return "K1 - K3";
      // case value > 3 && value <= 6:
      //   return "P1 - P3";
      // case value > 6 && value <= 9:
      //   return "P4 - P6";
      // case value > 9 && value <= 12:
      //   return "S1 - S3";
      // case value > 12 && value <= 15:
      //   return "S4 - S6";
      // case value > 15:
      //   return "大專";
    }
  }

  submitInputForm() {
    const value = this.inputForm.value;
    const data = JSON.stringify(value);
    console.log(data);

    const navigationExtras: NavigationExtras = {
      queryParams: {
        data: data
      }
    };
    this.navCtrl.navigateForward(["/firebase/real-estate"], navigationExtras);
  }

  submitFilterForm() {
    const value = this.FilterForm.value;
    const data = JSON.stringify(value);
    console.log(value);

    // form - results
    const navigationExtras: NavigationExtras = {
      queryParams: {
        data: data
      }
    };
    // this.navCtrl.navigateForward(["/firebase/form-results"], navigationExtras);
    this.navCtrl.navigateForward(["/firebase/real-estate"], navigationExtras);

    // this.firebaseService.getFilteredSupplierList(cate_1).subscribe(res => {
    //   console.log(res);
    // });

    // this.firebaseService.getAllSupplier().subscribe(res => {
    //   console.log(res);
    // });
  }

  onDismiss() {
    this.modalCtrl.dismiss();
  }

  onReset() {
    this.FilterForm = new FormGroup({
      // cate: new FormControl(""),
      subcate: new FormControl(""),
      class_size: new FormControl({ lower: 1, upper: 42 }),
      target_user_age: new FormControl({ lower: 1, upper: 16 }),
      class_length: new FormControl({ lower: 1, upper: 42 }),
      teaching_materials: new FormControl(""),
      message_teaching_materials: new FormControl(""),
      sq_timelimit: new FormControl(""),
      message: new FormControl("")
    });
  }
  ngOnInit() {}

  myFunction() {
    // this.CollapseForm = !this.CollapseForm;
    const elmnt = document.getElementById("content");
    elmnt.scrollIntoView();
  }

  AdvancedSearch() {
    this.CollapseForm = !this.CollapseForm;
    setTimeout(() => {
      const elmnt = document.getElementById("content");
      elmnt.scrollIntoView({
        block: "start",
        behavior: "smooth"
      });
    }, 300);
  }

  checkUserStatus() {
    firebase.auth().onAuthStateChanged(
      user => {
        if (user) {
          // User is signed in.

          // this.uid = user.uid;
          // this.displayName = user.displayName;
          // this.photoURL = user.photoURL;
          const displayName = user.displayName;
          const email = user.email;
          const emailVerified = user.emailVerified;
          const photoURL = user.photoURL;
          const uid = user.uid;
          const phoneNumber = user.phoneNumber;
          const providerData = user.providerData;
          // user.getIdToken().then(accessToken => {
          //   console.log("accessToken: ", accessToken);

          //   document.getElementById("sign-in-status").textContent = "Signed in";
          //   document.getElementById("sign-in").textContent = "Sign out";
          //   this.signin = "Sign out";
          //   this.displayName = displayName;
          //   this.uid = uid;
          //   this.photoURL = photoURL;
          //   document.getElementById(
          //     "account-details"
          //   ).textContent = JSON.stringify(
          //     {
          //       displayName: displayName,
          //       email: email,
          //       emailVerified: emailVerified,
          //       phoneNumber: phoneNumber,
          //       photoURL: photoURL,
          //       uid: uid,
          //       accessToken: accessToken,
          //       providerData: providerData
          //     },
          //     null,
          //     "  "
          //   );
          // });

          // this.navCtrl.navigateForward("/firebase/categories");
          //   this.navCtrl.navigateForward("/");
        } else {
          // User is signed out.
          // document.getElementById("sign-in-status").textContent = "Signed out";
          // document.getElementById("sign-in").textContent = "Sign in";
          this.signin = "Sign in";
          // document.getElementById("account-details").textContent = "null";
          //    this.navCtrl.navigateForward("/auth/signup");
        }
      },
      function(error) {
        console.log(error);
      }
    );
  }

  show(value: boolean) {
    this.showMessageTeachingMaterial = value;
  }

  selectAll(value: number) {
    if (value === value) {
      this.SELECT_ALL = value;
    }
  }
}
